import { z } from 'zod';
import { paginationQuerySchema } from '../pagination.js';
/** Les champs importes, listes une seule fois : sert aux messages de refus. */
export const PRODUCT_IMPORTED_FIELDS = [
    'codpro',
    'designation',
    'codmtr',
    'codalc',
    'degalc',
    'isInScope',
    'createdOnTheFly',
    'tav',
    'categorieFiscale',
];
export const listProductsQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(120).optional(),
    /** Filtre « dans le perimetre » (fait importe). */
    inScope: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((valeur) => (typeof valeur === 'boolean' ? valeur : valeur === 'true'))
        .optional(),
    /** Filtre sur l'exclusion decidee par l'exploitation. */
    horsPerimetreControle: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((valeur) => (typeof valeur === 'boolean' ? valeur : valeur === 'true'))
        .optional(),
    isActive: z
        .union([z.boolean(), z.enum(['true', 'false'])])
        .transform((valeur) => (typeof valeur === 'boolean' ? valeur : valeur === 'true'))
        .optional(),
});
/**
 * Attributs de gestion d'un article : **seule** charge utile acceptee par l'API.
 *
 * Le schema est `strict()` : toute autre propriete (designation, codalc, degalc,
 * isInScope...) fait echouer la validation. C'est la traduction technique de la
 * regle 13 — les faits importes ne sont jamais modifiables a la main.
 */
export const updateProductGestionSchema = z
    .object({
    /** `null` detache l'article de sa famille ; une chaine le rattache. */
    familyId: z.string().uuid().nullable().optional(),
    horsPerimetreControle: z.boolean().optional(),
    commentaire: z.string().trim().max(2000).nullable().optional(),
})
    .strict()
    .refine((valeur) => Object.values(valeur).some((champ) => champ !== undefined), {
    message: 'Aucune modification fournie',
});
//# sourceMappingURL=product.js.map